import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { ReactNode } from 'react';

import { DropdownMenuContent, DropdownMenuContentProps } from './Content';
import { DropdownMenuTitle } from './Title';

import { IconButton } from '../Buttons';
import { HorizontalDotsIcon } from '../Icons';
import { StringNodeGuard } from '../helpers';

const DropdownMenuProvider = DropdownMenuPrimitive.Root;

const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

type DropDownMenuProps = {
  /**
   * The node that will be displayed on screen
   * It needs to be able to hold a ref
   */
  trigger?: ReactNode;

  /**
   * Default icon of the trigger
   */
  triggerIcon?: ReactNode;

  /**
   * Only works if title is of string type
   */
  triggerClassName?: string;

  /**
   * The content of the default trigger (Icon Btn + 3 hoz dots)
   */
  tooltipContent?: ReactNode;

  className?: string;

  title?: ReactNode;

  /**
   * Only works if title is of string type
   */
  addTitleSeparator?: boolean;

  /**
   * Only works if title is of string type
   */
  titleClassName?: string;

  /**
   * Use to pass in Item, SubItem, Radio/Checkbox dropdown items
   */
  children: ReactNode;

  /**
   * Renders the trigger in a disabled state
   */
  disabled?: boolean;
} & Pick<DropdownMenuContentProps, 'sideOffset' | 'align' | 'side' | 'alignOffset'>;

export function DropdownMenu({
  trigger,
  tooltipContent,
  triggerIcon,
  triggerClassName,
  disabled,

  className,
  side,
  align,
  alignOffset,
  sideOffset,

  title,
  addTitleSeparator,
  titleClassName,

  children,
}: DropDownMenuProps) {
  return (
    <DropdownMenuProvider>
      <DropdownMenuTrigger asChild>
        {trigger || (
          <IconButton
            tooltipContent={tooltipContent}
            variant="ghost"
            className={triggerClassName}
            disabled={disabled}
          >
            {triggerIcon ?? <HorizontalDotsIcon size={18} />}
          </IconButton>
        )}
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className={className}
        side={side}
        align={align}
        alignOffset={alignOffset}
        sideOffset={sideOffset}
      >
        {title && (
          <StringNodeGuard node={title}>
            <DropdownMenuTitle className={titleClassName} bottomSeparator={addTitleSeparator}>
              {title}
            </DropdownMenuTitle>
          </StringNodeGuard>
        )}

        {children}
      </DropdownMenuContent>
    </DropdownMenuProvider>
  );
}
